import React from 'react'
import { Paper } from '@mui/material'
import { grey } from '@mui/material/colors'

export const DescriptionControl = () => {
  return (
    <Paper sx={{ whiteSpace: 'pre-wrap', p: 1, backgroundColor: 'rgb(255, 255, 255, 0.9)', fontSize: 14, fontWeight: 'bold', color: grey[700] }}>
      {'洪水浸水想定区域：想定し得る最大規模の降雨により氾濫した場合に浸水が想定される範囲\n'}
      {'現時刻の浸水範囲計算結果：現時刻までの実況雨量より浸水が推定される範囲'}
    </Paper>
  )
}
